import appBackupPlan from "../../views/appPlans/backup.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("backupplan", {
    url: "backupplan/:id",
    parent: "app",
    views: {
      view: {
        template: appBackupPlan,
      },
    },
    reloadOnSearch: false,
    data: { title: "Backup Plan" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/backupPlan/backupPlan.urls.js